<template>
  <!-- 分店 -->
  <section class="section photos">
    <div class="container">
      <div class="columns is-multiline is-mobile">
        <div class="column is-12 is-hidden-tablet">
          <!-- <figure class="image player is-16by9">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/GmWTZIfTeZo?autoplay=0&amp;mute=1"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen=""
              class="has-ratio"
            ></iframe>
          </figure> -->
        </div>

        <div class="column is-6" v-for="(item, index) in items" :key="index">
          <div class="image">
            <img v-lazy="item" alt="..." />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import store from "@/store";

export default {
  props: {
    items: {
      type: Array,
    },
  },
  components: {},
  data() {
    return {
    };
  },
  created() {},
  methods: {},
};
</script>
<style scoped>
.hero-body,
.section {
  padding: 3rem 1.5rem;
}
.container {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}
.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}
.columns:last-child {
  margin-bottom: -1.5rem;
}
.columns.is-multiline {
  flex-wrap: wrap;
}

.columns.is-mobile {
  display: flex;
}
.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
  box-sizing: border-box;
}
.columns.is-mobile > .column.is-12 {
  flex: none;
  width: 100%;
}
.image {
  display: block;
  position: relative;
}
.image img {
  display: block;
  height: auto;
  width: 100%;
}
@media print, screen and (min-width: 769px) {
  .is-hidden-tablet {
    display: none !important;
  }
  .column.is-12,
  .column.is-12-tablet {
    flex: none;
    width: 100%;
  }
  .column.is-6,
  .column.is-6-tablet {
    flex: none;
    width: 50%;
  }
  .columns:not(.is-desktop) {
    display: flex;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/gallery/components/SonIndex.vue